<template>
    <li class="team-timeline__presence">
        <v-icon small aria-hidden="true">{{ entry ? 'mdi-login' : 'mdi-logout' }}</v-icon>
        <div>
            <strong>{{ entry ? 'Entrata' : 'Uscita' }} · {{ originalTime }}</strong>
            <div v-if="countedTime && countedTime !== originalTime" class="mc-caption">Conteggio {{ entry ? 'dalle' : 'fino alle' }} {{ countedTime }}</div>
        </div>
    </li>
</template>
<script>
import { clockTime } from "./day-model.mjs";
export default {
    name: "TeamPresenceMarker",
    props: {
        marker: { type: Object, required: true }, entry: { type: Boolean, default: false },
        dayStart: { type: String, required: true }, dayEnd: { type: String, required: true },
    },
    computed: {
        originalTime() { return this.marker.original ? this.time(this.marker.original) : "Non ancora registrata"; },
        countedTime() { return this.marker.counted ? this.time(this.marker.counted) : ""; },
    },
    methods: {
        time(value) {
            const timestamp = Date.parse(value), time = clockTime(value);
            if (timestamp >= Date.parse(this.dayStart) && timestamp < Date.parse(this.dayEnd)) return time;
            const date = new Intl.DateTimeFormat("it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit" }).format(new Date(value));
            return `${time} (${date})`;
        },
    },
};
</script>
